const MarkReadAllIcon = () =>
{
      return (
            <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        d="M14.3875 5.00365C14.0625 4.67865 13.5375 4.67865 13.2125 5.00365L8.51248 9.70365L9.68748 10.8786L14.3875 6.17031C14.7042 5.85365 14.7042 5.32031 14.3875 5.00365ZM17.9208 4.99531L9.68748 13.2286L6.78748 10.337C6.46248 10.012 5.93748 10.012 5.61248 10.337C5.28748 10.662 5.28748 11.187 5.61248 11.512L9.09582 14.9953C9.42082 15.3203 9.94582 15.3203 10.2708 14.9953L19.0958 6.17865C19.4208 5.85365 19.4208 5.32865 19.0958 5.00365H19.0875C18.7708 4.67031 18.2458 4.67031 17.9208 4.99531ZM0.90415 11.5203L4.38748 15.0036C4.71248 15.3286 5.23748 15.3286 5.56248 15.0036L6.14582 14.4203L2.07915 10.337C1.75415 10.012 1.22915 10.012 0.90415 10.337C0.57915 10.662 0.57915 11.1953 0.90415 11.5203Z"
                        fill="#34B766"
                  />
            </svg>
      )
}

export default MarkReadAllIcon